import { Card, CardBody, CardTitle, CardText, Row, Col, Badge, Container } from "reactstrap";
import { useEffect, useState } from "react";
import EmailLogService from "../../../services/KangarooServices/EmailLogService";
import BreadCrumb from "../../../Components/Common/BreadCrumb";



const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });
};

const MetaRow = ({ label, value }) => (
    <div className="d-flex flex-column flex-sm-row gap-1 mb-2">
        <span className="fw-semibold text-secondary text-nowrap" style={{ minWidth: "70px" }}>
            {label}:
        </span>
        <span className="text-dark text-break">{value}</span>
    </div>
);

const EmailCard = ({ email }) => (
    <Card className="h-100 shadow-sm border rounded-3 bg-white">
        <CardBody className="p-4">
            {/* Header */}
            <div className="d-flex justify-content-between align-items-start mb-3 gap-2">
                <CardTitle tag="h6" className="fw-bold text-dark mb-0 lh-sm">
                    {email.subject}
                </CardTitle>
                <div className="d-flex flex-column align-items-end gap-1 flex-shrink-0">
                    <Badge color={email.emailSend ? "success" : "danger"} pill className="px-2 py-1 small">
                        {email.emailSend ? "Sent" : "Failed"}
                    </Badge>
                    <span className="text-muted" style={{ fontSize: "0.7rem" }}>
                        #{email.id}
                    </span>
                </div>
            </div>

            {/* Divider */}
            <hr className="my-3 text-secondary opacity-25" />

            {/* Metadata */}
            <div className="mb-3">
                <MetaRow label="From" value={email.from} />
                <MetaRow label="To" value={email.to} />
                <MetaRow label="Date" value={formatDate(email.date)} />
            </div>

            {/* Message Preview */}
            <div className="mb-3">
                <p className="fw-semibold text-secondary small mb-1 text-uppercase ls-1">Message</p>
                <div
                    className="p-3 rounded-2 border small text-dark"
                    style={{ backgroundColor: "#f8f9fa" }}
                    dangerouslySetInnerHTML={{ __html: email.message }}
                />
            </div>

            {/* Error Response */}
            {!email.emailSend && email.emailErrorResponse && (
                <div>
                    <p className="fw-semibold text-danger small mb-1 text-uppercase">Error Details</p>
                    <CardText
                        className="p-3 rounded-2 border border-danger border-opacity-25 small text-danger mb-0"
                        style={{ backgroundColor: "#fff5f5", whiteSpace: "pre-wrap", wordBreak: "break-word" }}
                    >
                        {email.emailErrorResponse}
                    </CardText>
                </div>
            )}
        </CardBody>
    </Card>
);


const EmailLogs = () => {

    const [data, setData] = useState([]);

    useEffect(() => {
        const fetchEmailLogs = async () => {
            const response = await EmailLogService.getAll();
            setData(response);
        };
        fetchEmailLogs();
    }, []);
    return (
        <div className="page-content">


            <BreadCrumb
                title="Email Logs"
                pageTitle="Email Logs"
            />
            <Container fluid className="py-4">

                <div className="mb-4">
                    <h5 className="fw-bold text-dark mb-1">Email Log</h5>
                    <p className="text-muted small mb-0">{data.length} records found</p>
                </div>
                <Row className="g-4">
                    {data.map((email) => (
                        <Col key={email.id} xs={12} md={6} xl={4}>
                            <EmailCard email={email} />
                        </Col>
                    ))}
                </Row>
            </Container>
        </div>
    );
};

export default EmailLogs;